import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const TextFormatBold16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M5.22783 13C4.78672 13 4.47067 12.9022 4.27968 12.7067C4.09322 12.5066 4 12.1906 4 11.7586V4.24148C4 3.80037 4.0955 3.48431 4.28649 3.29331C4.48203 3.09777 4.79581 3 5.22783 3C6.69712 3 8.72879 3 9.58724 3C10.8192 3 11.8377 4.09059 11.8377 5.42733C11.8377 6.42779 11.3374 7.24283 10.337 7.70669C11.6286 7.94279 12.3529 9.25319 12.3529 10.2014C12.3529 11.3472 11.7669 13 9.86371 13C9.30824 13 6.69584 13 5.22783 13ZM8.86546 8.55935H6V11.4789H8.86546C9.44444 11.4789 10.2551 10.9123 10.2551 9.99863C10.2551 9.08492 9.44444 8.55935 8.86546 8.55935ZM6 4.52114V7.10641H8.6441C9.0434 7.10641 9.86371 6.73266 9.86371 5.7778C9.86371 4.82293 8.9783 4.52114 8.6441 4.52114H6Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
